/** Search functionality */

function debounce<T extends (...args: any[]) => void>(fn: T, delay = 120): T {
  let timer: ReturnType<typeof setTimeout>
  return function (this: any, ...args: any[]) {
    clearTimeout(timer)
    timer = setTimeout(() => fn.apply(this, args), delay)
  } as T
}

export function initSearch(): void {
  const input = document.getElementById('search_input') as HTMLInputElement | null
  const result = document.querySelector<HTMLElement>('.search_result')
  if (!input || !result) return

  let searchData: Array<{ title: string; tags: string; url: string }> | null = null

  input.addEventListener('focus', () => {
    result.style.display = 'block'
  })

  document.addEventListener('click', (e) => {
    const target = e.target as HTMLElement
    if (target.id !== 'search_input' && !target.classList.contains('search_result') && !target.classList.contains('search_item')) {
      result.style.display = 'none'
    }
  })

  input.addEventListener(
    'keyup',
    debounce(async function (this: HTMLInputElement) {
      const keywords = this.value.toLowerCase()
      if (!keywords) {
        result.innerHTML = ''
        return
      }

      if (!searchData) {
        try {
          const resp = await fetch('/search.json')
          searchData = await resp.json()
        } catch {
          return
        }
      }

      let html = ''
      for (const item of searchData!) {
        const k = (item.title + item.tags).toLowerCase()
        if (k.includes(keywords)) {
          html += `<a class="search_item" href="${item.url}">${item.title}</a>`
        }
      }
      result.innerHTML = html
    }, 120)
  )
}
